import React from "react"
import { isEmpty } from "lodash-es"
import { useFacilityAuditTrailContext } from "contexts/FacilityAuditTrailContext"
import { useCustomName } from "hooks"
import { FACILITY_KEY } from "utils/customNameHelpers"
import LoadingIndicator from "shared/LoadingIndicator"
import LoadMoreButton from "./LoadMoreButton"
import FacilityAuditTrailGroups from "./FacilityAuditTrailGroups"

const Content = () => {
  const { auditGroups, isLoading, page } = useFacilityAuditTrailContext()

  const { nameInSentence: facilityNameInSentence } = useCustomName(FACILITY_KEY)

  if (isLoading && page === 1) {
    return (<LoadingIndicator textValue="Loading audits ..." />)
  }

  if (isEmpty(auditGroups) && !isLoading) {
    return (
      <p className="text-center mb-12">
        There are no audits for this {facilityNameInSentence}.
      </p>
    )
  }

  return (
    <>
      <FacilityAuditTrailGroups />
      {
        isLoading ? <LoadingIndicator /> : <LoadMoreButton />
      }
    </>
  )
}

export default Content
